import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { id: "QuestionsView" }

import { onMounted, ref, watchEffect } from "vue";
import { Question, QuestionControllerService } from "../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionsView',
  setup(__props) {

const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  pageSize: 10,
  current: 1,
  title: "",
  tag: [],
});

const loadData = async () => {
  // 校验分页数量
  if (!searchParams.value.pageSize || searchParams.value.pageSize <= 0) {
    searchParams.value.pageSize = 5;
  }
  const res = await QuestionControllerService.listQuestionVoByPageUsingPost(
    searchParams.value
  );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }
};

onMounted(() => {
  loadData();
});
// 监听分页变量，改变时更新页面
watchEffect(() => {
  loadData();
});

const columns = [
  {
    title: "题号",
    dataIndex: "questionId",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "标签",
    slotName: "tag",
  },
  {
    title: "通过率",
    slotName: "acceptedRate",
  },
  {
    title: "发布时间",
    slotName: "createTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];
// 跳转到做题页面
const router = useRouter();
const toQuestion = (question: Question) => {
  router.push({
    path: `/view/question/${question.questionId}`,
  });
};

const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

const doSubmit = () => {
  searchParams.value = {
    ...searchParams.value,
    current: 1,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h1", null, "题目列表", -1)),
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "title",
              label: "题目名称",
              "label-col-flex": "70px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: searchParams.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.title) = $event)),
                  placeholder: "请输入题目名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "tag",
              label: "标签",
              "label-col-flex": "80px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_tag, {
                  modelValue: searchParams.value.tag,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.tag) = $event)),
                  "allow-clear": "",
                  class: "formItem",
                  placeholder: "请输入标签"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              style: {"width":"50%"},
              type: "primary",
              onClick: doSubmit
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("提交 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_divider, { size: 0 }),
    _createVNode(_component_a_space, null, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createTextVNode("每页题目数量 ")),
        _createVNode(_component_a_input_number, {
          modelValue: searchParams.value.pageSize,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.pageSize) = $event)),
          min: "1",
          placeholder: "每页题目数量",
          size: "small",
          style: {"width":"200px"}
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_divider, { size: 0 }),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
      onPageChange: onPageChange
    }, {
      tag: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tag, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      acceptedRate: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(`${
              (record.commitNum ?? 0) != 0
                ? (record.acceptedNum / record.commitNum) * 100
                : 0
            }%  (${record.acceptedNum ?? 0} / ${record.commitNum ?? 0})`), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      createTime: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD")), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (toQuestion(record))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("去做题")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})